import { selectVariantForAbTestId } from '../../store/abtest/abtest.selectors'
import { useSelectorWithProps } from '../utils/react-redux'

export const useAbTestVariant = id => useSelectorWithProps(selectVariantForAbTestId, { id })
